import { render } from "./LanguageEditModal.vue?vue&type=template&id=3ba8866e"
import script from "./LanguageEditModal.vue?vue&type=script&lang=js"
export * from "./LanguageEditModal.vue?vue&type=script&lang=js"

import "./LanguageEditModal.vue?vue&type=style&index=0&id=3ba8866e&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__